export default __webpack_public_path__ + "static/media/full3.19620005.jpg";